import { __assign, __rest } from "tslib";
/* eslint-disable react/button-has-type */
import React, { forwardRef } from 'react';
import { buttonStyle } from '@mercell/tailwind';
import cx from 'classnames';
import { twMerge } from 'tailwind-merge';
var renderContent = function (children, iconSettings) {
    if (iconSettings === void 0) { iconSettings = {}; }
    var Icon = iconSettings.Icon, _a = iconSettings.iconSide, iconSide = _a === void 0 ? 'left' : _a;
    var iconClassName = 'w-6 h-6 fill-current';
    if (!Icon) {
        return children;
    }
    if (!children && Icon) {
        return React.createElement(Icon, { className: iconClassName });
    }
    switch (iconSide) {
        case 'left':
        case 'top':
            return (React.createElement(React.Fragment, null,
                React.createElement(Icon, { className: cx(iconClassName, iconSide === 'left' && 'mr-2') }),
                React.createElement("span", null, children)));
        case 'right':
        case 'bottom':
            return (React.createElement(React.Fragment, null,
                React.createElement("span", null, children),
                React.createElement(Icon, { className: cx(iconClassName, iconSide === 'right' && 'ml-2') })));
        default:
            return children;
    }
};
export var Button = forwardRef(function (_a, ref) {
    var children = _a.children, scheme = _a.scheme, _b = _a.small, small = _b === void 0 ? false : _b, _c = _a.iconSettings, iconSettings = _c === void 0 ? {} : _c, _d = _a.type, type = _d === void 0 ? 'button' : _d, className = _a.className, _e = _a.disabled, disabled = _e === void 0 ? false : _e, rest = __rest(_a, ["children", "scheme", "small", "iconSettings", "type", "className", "disabled"]);
    return (React.createElement("button", __assign({}, rest, { type: type, className: twMerge(buttonStyle(scheme, disabled, small), (iconSettings.iconSide === 'top' ||
            iconSettings.iconSide === 'bottom') &&
            'flex-col', className), disabled: disabled, ref: ref }), renderContent(children, iconSettings)));
});
export default Button;
